import React, { useEffect, useState } from "react";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../Firebase/firebase";

const useGetUtils = () => {
  const [utils, setUtils] = useState({});

  const getUtils = async () => {
    const docRef = doc(db, "utils", process.env.REACT_APP_UTILS_FIRESTORE_DOC_ID);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      // console.log(docSnap.data())
      setUtils(docSnap.data());
    } else {
      console.log("nothing chief");
    }
  };

  useEffect(() => {
    getUtils()
  }, [])

  return { utils };
};

export default useGetUtils;
